module.exports = "/images/logo.png?cc7f95229a3f42f88fb000c1b4b61899";